<template>
  <div class="full-width">
    <AppEditForm
      padding
      class="row q-px-md q-mb-xl"
      @save="save"
      :edit="edit"
      :new="isNew"
    >
      <div class="gt-xl col-xl-2" />
      <div class="col-12 col-sm-9 col-xl-6 q-mt-md row">

        <div class="col-12 q-px-sm">
          <AppInput v-if="!isNew"
              label="Numero"
              v-model="enunciado.numero"
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput label="Descrição *" v-model="enunciado.texto" autogrow type="textarea"
           editable
           required
           maxlength="4000"
           showCounter
          />
        </div>
        <div class="col-12 q-px-sm">
          <AppInput
              label="Referência Legislativa"
              autogrow
              type="textarea"
              v-model="enunciado.referenciaLegislativa"
              v-if="enunciado.referenciaLegislativa || edit || userStore.admin"
              editable
              maxlength="4000"
              showCounter
          />
        </div>
        <div class="col-12 q-px-sm">
          <AppInput
              label="Link Acórdão"
              autogrow
              type="textarea"
              v-model="enunciado.linkAcordaos"
              v-if="enunciado.linkAcordaos || edit || userStore.admin"
              editable
              maxlength="2000"
              showCounter
          />
        </div>
        <div class="col-sm-12 col-12  q-px-sm">
          <AppSelect
              label="Tipo *"
              v-model="tipo"
              @filter="tipoFilter"
              :options="tipos"
              editable
          />
        </div>
        <div class="col-sm-8 col-12  q-px-sm">
          <AppSelect
              label="Situação *"
              v-model="situacao"
              @filter="situacaoFilter"
              :options="situacoes"
              editable
          />
        </div>
        <div class="col-sm-4 col-12  q-px-sm">
          <AppDateSelect label="Data da Situação *" v-model="enunciado.dataSituacaoEnunciado" editable required/>
        </div>
        <div class="col-12 q-px-sm text-right">
          <q-chip v-if="enunciado.statusEnvioBnp && userStore.admin" outline square color="green" text-color="white" icon="done">
            Enviado ao BNP
          </q-chip>
          <q-chip v-if="!enunciado.statusEnvioBnp && userStore.admin" outline square color="red" text-color="white" icon="close">
            Não enviado ao BNP
          </q-chip>
        </div>
      </div>
      <AppTimeline
        class="col-12 col-sm-3 col-xl-2"
        v-model="timeline"
        :edit="edit || isNew"
        :requires=0
      />
      <div class="gt-xl col-xl-2" />
      <div class="gt-xl col-xl-2" />
      <div class="col-xl-8 col-sm-12">
        <div class="col-12 q-px-sm">
          <q-chip outline color="primary" text-color="white">
            Processos Paradigmas
          </q-chip>
        </div>
        <AppInfiniteListForm v-model="processosparadigma">
          <ProcessoParadigma />
          <template v-slot:item="data">
            <MiniProcessoParadigma v-bind="data" />
          </template>
        </AppInfiniteListForm>
      </div>
      <div class="gt-xl col-xl-2" />
      <q-page-sticky
        position="bottom-right"
        :offset="[18, 18]"
        v-if="userStore.admin"
      >
        <AppSaveBtn v-if="edit" :disable="disableButton"/>
        <AppDeleteBtn v-if="!isNew" @click="showConfirmDeletion" :disable="disableButton"/>
        <AppEditBtn v-if="!isNew" @click="toggleEditMode" />
      </q-page-sticky>
    </AppEditForm>
    <TjpaDemandasDeleteModal
      :show="showConfirmDeletionModal"
      @update:show="showConfirmDeletionModal = $event"
      @confirmDeletion="confirmDeletion"
      :id="$route.params.id"
    />
  </div>
</template>


<script setup>
import MiniProcessoParadigma from "@/components/app/AppMiniProcessoPje.vue";
MiniProcessoParadigma;
import AppInfiniteListForm from "@/components/app/AppInfiniteListForm.vue";
AppInfiniteListForm;
import ProcessoParadigma from "@/components/app/AppProcessoPje.vue";
import AppEditForm from "../app/AppEditForm.vue";
import AppDeleteBtn from "../app/AppDeleteBtn.vue";
import AppEditBtn from "../app/AppEditBtn.vue";
import AppSaveBtn from "../app/AppSaveBtn.vue";
import AppInput from "../app/AppInput.vue";
import AppSelect from "../app/AppSelect.vue";
import AppTimeline from "@/components/app/AppTimeline.vue";
AppTimeline;
import TjpaDemandasDeleteModal from "../tjpa-demandas-delete-modal.vue";

import { useProcessoParadigmaStore } from "@/store/processoparadigma-store";
import { useEnunciadoSituacaoStore } from "@/store/enunciado-situacao-store";
import { useEnunciadoTipoStore } from "@/store/enunciado-tipo-store";

import { useEnunciadoStore } from "@/store/enunciado-store";
import { useUserStore } from "@/store/user-store";

import { ref, computed, defineProps } from "vue";
import { useQuasar } from "quasar";
import { useRouter, useRoute } from "vue-router";

const quasar = useQuasar();
const router = useRouter();
const route = useRoute();

const userStore = useUserStore();
const situacaoStore = useEnunciadoSituacaoStore();
situacaoStore.fetch();
const tipoStore = useEnunciadoTipoStore();
tipoStore.fetch();

const notify = (...p) => quasar.notify(...p);

const enunciadoStore = useEnunciadoStore();

import {
  filterFunction,
  baseUrlDelete,
  DELETE_FAILURE,
  DELETE_SUCCESS, CREATE_SUCCESS, ALTER_SUCCESS
} from "@/DemandasRepetitivas";
import AppDateSelect from "@/components/app/AppDateSelect.vue";

const procStore = useProcessoParadigmaStore();

const props = defineProps({ id: { type: String } });
props.id && enunciadoStore.fetchStg(props.id);

const _edit = ref(false);

const enunciado = computed(() => enunciadoStore.stgTema);

const processosparadigma = computed({
  get: () => edit.value ? procStore.processos: enunciado.value.processosParadigma,
  set: v => (procStore.processos = v)
});

const sourceEnunciado = computed(
  () => props.id && enunciadoStore.all.find(t => t.id == props.id)
);

const isNew = computed(() => !props.id);
const showConfirmDeletionModal = ref(false);
const disableButton = ref(false);


const admin = computed(() => userStore.admin)
const situacoes = computed(() => situacaoStore.filtered);
const tipos = computed(() => tipoStore.filtered);

const situacao = computed({
  get: () => (situacaoStore.all?.find(s => s.id == enunciado.value.idSituacaoEnunciado)),
  set: v => (enunciado.value.idSituacaoEnunciado = v.id)
});

const tipo = computed({
  get: () => (tipoStore.all?.find(s => s.id == enunciado.value.idTipoEnunciado)),
  set: v => (enunciado.value.idTipoEnunciado = v.id)
});

const edit = computed({get:() => (_edit.value && admin.value),set:v=>(_edit.value = v)})

const toggleEditMode = () => {
  edit.value = !edit.value ;
  if(edit.value == true){
    procStore.processos = enunciado.value.processosParadigma;
  }
  if (edit.value == false && enunciado.value.equals(sourceEnunciado.value) == false) {
    notify({
      message: "Existem Alterações não salvas",
      color: "warning"
    });
  }
};

if (isNew.value) {
  enunciadoStore.clearStg();
  procStore.clear();

  edit.value = false;
  toggleEditMode();
}

const timeline = computed({
  get: () => {
    const { dataCriacao} = enunciado.value;
    return [
      { order: 0, name: "Criação *", date: dataCriacao, icon: "add" }
    ];
  },
  set: v => {
    let timelineFields = ["Criacao"];
    timelineFields = timelineFields.map(
        fieldName => (fieldName = `data${fieldName}`)
    );
    timelineFields.forEach(
        (fieldName, i) => (enunciado.value[fieldName] = v[i].date)
    );
  }
});
const situacaoFilter = (val, update) =>
  filterFunction(...[situacoes.value, situacaoStore.all, val, update]);

const tipoFilter = (val, update) =>
    filterFunction(...[tipos.value, tipoStore.all, val, update]);

const save = async () => {

  if (!situacao.value) {
    notify({
      message: "É obrigatória a escolha de uma situação.",
      color: "warning"
    });
    return;
  }

  if (!tipo.value) {
    notify({
      message: "É obrigatória a escolha de um tipo.",
      color: "warning"
    });
    return;
  }

  disableButton.value = true;

  let success_msg = isNew.value ? CREATE_SUCCESS : ALTER_SUCCESS;

  const reload = () => enunciadoStore.clearStg();
  const failure = msg =>
      notify({
        message: msg,
        color: "negative"
      });
  const success = (id) =>
    notify({
      message: `A Súmula ${id} ` + success_msg,
      color: "positive"
    });

  const successAndReload = id => {
    success(id);
    router.push("/sumulahome");
    if(isNew.value){
      reload();
    }
  };
  try {
    const readResponse = await enunciadoStore.saveStg();
    successAndReload(readResponse.data);
    //failure(id);
  } catch (e) {
    disableButton.value = false;
    if(e.response.status == 401){
      failure("Sessão Expirou.");
      router.push("/sumulahome");
      reload();
    }else{
      failure(e.response.data.message);
    }
  }
};

const goHome = () => router.push("/sumulahome");

const showConfirmDeletion = () => (showConfirmDeletionModal.value = true);
const confirmDeletion = () => {
  disableButton.value = true;
  const reload = () => goHome();

  const notifyObj = (message, color) => ({ message, color });
  const failure = () => notify(notifyObj(DELETE_FAILURE, "negative"));
  const success = () => notify(notifyObj(DELETE_SUCCESS, "positive"));

  const successAndReload = () => {
    success();
    reload();
  };
  const httpOk = r => r.status == 200;
  const readResponse = r => (httpOk(r) ? successAndReload() : failure());

  baseUrlDelete(`enunciado/${route.params.id}`)
    .then(readResponse)
    .catch(failure);
};
</script>

<style lang="scss" >
@import "@/styles/quasar.variables.sass";

.tjpa-select-input {
  max-height: 30vh !important;
}

.AppSelect__dialog {
  margin-top: 90px;
}
</style>
